import { useMemo } from 'react';

import { DatabaseViewFieldType, ResourceStatusEnum, ViewTypeEnum } from '@/types/schema';

import { SurveyEditorDetailsFragment } from '../../graphql/fragments/generated/SurveyEditorDetails';
import { useSurveyEditorDetailsQuery } from '../../graphql/queries/generated/surveyEditorDetails';

interface Params {
  contentId: string;
}

const useSurveyEditorData = ({ contentId: id }: Params) => {
  const [{ fetching, error, data }] = useSurveyEditorDetailsQuery({
    variables: {
      filters: { id, versionStatus: ResourceStatusEnum.Draft },
    },
  });

  const survey = data?.content as SurveyEditorDetailsFragment | null;
  const dbMetadataId = survey?.dbMetadataId;
  const viewId = survey?.dbViewIds.find(({ type }) => type === ViewTypeEnum.FormView)?.viewId;

  const fields = useMemo(() => {
    const databaseView = survey?.databaseViews?.find((view) => view.id === viewId);
    const metadataFields = survey?.databaseMetadata?.fields;
    const viewFields = databaseView?.format.fields;

    if (metadataFields && viewFields) {
      return { metadataFields, viewFields: viewFields as DatabaseViewFieldType[] };
    }

    return null;
  }, [survey?.databaseMetadata?.fields, survey?.databaseViews, viewId]);

  return {
    survey,
    fetching,
    error,
    dbMetadataId,
    viewId,
    fields,
  };
};

export default useSurveyEditorData;
